import * as React from "react";
import { useToggle } from "react-use";
import { UserModal } from "./userModal";
import { UserAvatar } from "@/components/ui/userAvatar";
import { Userdata } from "@/types/user";
import { getUserDisplayName } from "@/helpers/userDisplay";

interface Props {
  user: Userdata;
}

export const UsersTableRow: React.FC<Props> = ({ user }) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  return (
    <tr>
      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
        <UserAvatar user={user} size="sm" className="mr-2" />
      </td>

      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
        {getUserDisplayName(user)}
      </td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.email}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.phoneNumber}</td>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{user.isActive ? "Yes" : "No"}</td>
      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
        {isOpen && <UserModal user={user} isOpen={isOpen} setIsOpen={toggleIsOpen} />}

        <button onClick={toggleIsOpen} type="button" className="text-primary">
          Edit<span className="sr-only">, {user.email}</span>
        </button>
      </td>
    </tr>
  );
};
